import whatInput from "what-input";
// Import SCSS (processed by Vite)
import "../scss/app.scss";

var $ = jQuery;
window.$ = $;

import "./lib/menu";
import "./lib/slick";
import "./lib/map";
import "./lib/modal";
import "./lib/video";
import { general } from "./lib/general";

general();